import React from "react";
import {
  alpha,
  ThemeProvider,
  withStyles,
  makeStyles,
  createTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import "./CustomTextField.scss";

const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "green",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "red",
      },
      "&:hover fieldset": {
        borderColor: "yellow",
      },
      "&.Mui-focused fieldset": {
        borderColor: "green",
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function CustomTextField({
  value,
  onChangeValue,
  label,
  fieldKey,
  placeholder,
  inputLabelShrink = false,
  isPassword,
  icon,
  className = "",
  style = {},
  isRequired = false,
}) {
  const classes = useStyles();
  return (
    <div
      className={`shared-dexter-custom-text-field ${className}`}
      style={{ ...style }}
    >
      {icon && <img src={icon} />}

      <TextField
        style={{ width: "85%" }}
        label={label}
        type={isPassword ? "password" : "text"}
        id="filled-size-normal"
        value={value}
        InputLabelProps={{
          shrink: inputLabelShrink,
        }}
        onChange={(e) =>
          onChangeValue({
            target: { key: fieldKey, value: e.target.value },
          })
        }
        variant="filled"
        required={isRequired}
        placeholder={placeholder || label}
      />
    </div>
  );
}
